import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5568ac8b&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=5568ac8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568ac8b",
  null
  
)

export default component.exports